import React from 'react';
import PropTypes from 'prop-types';
import { Container, Loader } from './styles';
import { COLOR_GRAY_90 } from 'styles/variables/colors';

const Props = {
  children: PropTypes.node.isRequired,
  variant: PropTypes.oneOf([
    'default',
    'defaultOutline',
    'primary',
    'secondary',
    'facebook',
    'link',
    'danger',
  ]),
  marginTop: PropTypes.number,
  marginRight: PropTypes.number,
  marginBottom: PropTypes.number,
  type: PropTypes.string,
  onClick: PropTypes.func,
  isInline: PropTypes.bool,
  isLoading: PropTypes.bool,
  minWidth: PropTypes.number,
};

const DefaultProps = {
  variant: 'default',
  type: 'button',
  onClick: () => {},
  isInline: false,
  isLoading: false,
};

/**
 * Basic button
 * @param {object} props
 * @param {string} props.variant - the variant theme
 * @param {Function} props.onClick - the click function handler
 */
export default function Button({
  children,
  variant,
  type,
  marginTop,
  marginRight,
  marginBottom,
  onClick,
  isInline,
  isLoading,
  minWidth,
  disabled,
}) {
  const fillColor = variant === 'default' ? COLOR_GRAY_90 : '#fff';

  return (
    <Container
      onClick={onClick}
      variant={variant}
      type={type}
      marginTop={marginTop}
      marginRight={marginRight}
      marginBottom={marginBottom}
      isInline={isInline}
      disabled={disabled || isLoading}
      disableElevation={true}
      minWidth={minWidth}
    >
      {isLoading ? <Loader fillColor={fillColor} size={20} thickness={5} /> : children}
    </Container>
  );
}

Button.propTypes = Props;
Button.defaultProps = DefaultProps;
